/**
 * Password strength utilities for the frontend.
 * Used by ResetPassword, ForgotPassword (reset form), and ProfileModal Security tab.
 *
 * Rules mirror backend validate_password_complexity() exactly — any change here
 * must be reflected in backend/server.py validate_password_complexity().
 */

/**
 * Check password strength against all 5 complexity rules.
 *
 * @param {string} password - The raw (plaintext) password to check.
 * @returns {{ minLength: boolean, hasUpper: boolean, hasLower: boolean, hasDigit: boolean, hasSpecial: boolean, score: number, isValid: boolean }}
 */
export function checkPasswordStrength(password) {
    const minLength  = password.length >= 12;
    const hasUpper   = /[A-Z]/.test(password);
    const hasLower   = /[a-z]/.test(password);
    const hasDigit   = /[0-9]/.test(password);
    const hasSpecial = /[!@#$%^&*()\,.\?":{}|<>\-_=+]/.test(password);

    const score = [minLength, hasUpper, hasLower, hasDigit, hasSpecial].filter(Boolean).length;
    const isValid = minLength && hasUpper && hasLower && hasDigit && hasSpecial;

    return { minLength, hasUpper, hasLower, hasDigit, hasSpecial, score, isValid };
}
